import { render, staticRenderFns } from "./DocsNavigationSubmenu.vue?vue&type=template&id=0e4d83a1&scoped=true&"
import script from "./DocsNavigationSubmenu.vue?vue&type=script&lang=js&"
export * from "./DocsNavigationSubmenu.vue?vue&type=script&lang=js&"
import style0 from "./DocsNavigationSubmenu.vue?vue&type=style&index=0&id=0e4d83a1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e4d83a1",
  null
  
)

export default component.exports